import { Avatar, TableCell, TableRow } from '@mui/material';
import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import Label from '../elements/label/Label';
import ConvertToAutoSuggestion from './ConvertToAutoSuggestion';

export default function ProductListContent({ 
  row, 
  columns, 
  index, 
  fetchData,
  setMessage,
  setSnackbarOpen 
}) {
  const { id, title, category_data, price, status, pictures } = row;
  const [iconLoaded, setIconLoaded] = useState(false);
  const navigate = useNavigate();

  const clickableRowStyle = {
    cursor: 'pointer',
    textDecoration: 'none',
    color: 'inherit',
  };

  useEffect(() => {
    if (firstPicture) {
      const img = new Image();
      img.src = firstPicture;
      img.onload = () => setIconLoaded(true);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  function handleRowClick() {
    navigate(`/products/${id}`);
  }

  const firstPicture = pictures && pictures.length > 0 ? pictures[0] : null;

  const getColumnContent = (column) => {
    const { id: columnId, nested } = column;

    if (columnId === 'sno') {
      return index + 1;
    } else if (columnId === 'pictures') {
      return iconLoaded ? (
        <Avatar
          alt={title}
          src={firstPicture}
          sx={{ mx: 'auto', width: 50, height: 50 }}
        />
      ) : (
        <Avatar 
          alt={title} 
          src='/default_product_category.png' 
          sx={{ mx: 'auto', width: 50, height: 50 }} 
        />
      );
    } else if (columnId === 'title') {
      return title.charAt(0).toUpperCase() + title.slice(1);
    } else if (columnId === 'category_data.name') {
      return category_data?.name || 'NA';
    } else if (columnId === 'price') {
      const formattedPrice = parseFloat(price).toLocaleString('en-US', {maximumFractionDigits: 2});
      return `$${formattedPrice}`;
    } else if (columnId === 'status') {
      return (
        <Label color={status === 'active' ? 'success' : 'default'}>
          {status}
        </Label>
      );
    } else if (columnId === 'action') {
      return (
        <ConvertToAutoSuggestion
          product={row}
          fetchData={fetchData}
          setMessage={setMessage}
          setSnackbarOpen={setSnackbarOpen}
        />
      );
    } else if (nested) {
      const nestedProperties = columnId.split('.');
      let nestedValue = row;
      for (const property of nestedProperties) {
        if (nestedValue && nestedValue.hasOwnProperty(property)) {
          nestedValue = nestedValue[property];
        } else {
          nestedValue = null;
          break;
        }
      }
      return nestedValue;
    } else {
      return row[columnId] || 'NA';
    }
  };

  const handleCellClick = (e, columnId) => {
    // Prevent navigation when clicking on action column
    if (columnId === 'action') {
      e.stopPropagation();
      return;
    }
    handleRowClick();
  };

  return (
    <TableRow
      hover
      key={id}
      style={clickableRowStyle}
    >
      {columns.map((column, columnIndex) => (
        <TableCell
          key={column.id}
          align="center"
          onClick={(e) => handleCellClick(e, column.id)}
          sx={
            columns.length === columnIndex
              ? {
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  width: column.id === 'pictures' ? '80px' : 'auto',
                }
              : {}
          }>
          {getColumnContent(column)}
        </TableCell>
      ))}
    </TableRow>
  );
}